module.exports = __webpack_public_path__ + "img/checkmark-icon.e07c0395.svg";